import { AutogenModelDriverSettlementProfile, AutogenRowDriverSettlementProfile } from "./autogen/AutogenModelDriverSettlementProfile";

export class ModelDriverSettlementProfile extends AutogenModelDriverSettlementProfile<RowDriverSettlementProfile> {
	constructor() {
		super(RowDriverSettlementProfile);
	}
}

export class RowDriverSettlementProfile extends AutogenRowDriverSettlementProfile {
}